import React from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";

import styled from "styled-components";
import vars from "@exovera/narrative-tracker-variables";

import ChangePassword from "./ChangePassword.jsx";
import CreateNewPassword from "./CreateNewPassword.jsx";
import ForgotPassword from "./ForgotPassword.jsx";
import Login from "./Login.jsx";

// loaded first, outside .login
const Switch = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	opacity: ${(props) => (props.hide ? 0 : 1)};
	transition: opacity 250ms ease-out;
`;
const Note = styled.p`
	position: absolute;
	width: 100%;
	bottom: 20px;
	text-align: center;
	color: ${(props) => props.textColor};
	${vars.mainfont};
	font-size: 14px;
`;

const LoginSwitch = (props) => {
	return (
		<div>
			<Transition in timeout={1} appear>
				{(status) => {
					return (
						<Switch hide={status === "entering"}>
							{props.forgotPassword ? (
								<ForgotPassword
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputEmail={props.loginInputEmail}
									loginInputPassword={props.loginInputPassword}
								/>
							) : props.createNewPassword ? (
								<CreateNewPassword
									codeDeliveryMessage={props.codeDeliveryMessage}
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputVerificationCode={props.loginInputVerificationCode}
									loginInputNewPassword={props.loginInputNewPassword}
								/>
							) : props.forceChangePassword ? (
								<ChangePassword
									codeDeliveryMessage={props.codeDeliveryMessage}
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputVerificationCode={props.loginInputVerificationCode}
									loginInputChangePasswordNew={props.loginInputChangePasswordNew}
									loginInputChangePasswordOld={props.loginInputChangePasswordOld}
									userJustLoggedIn={props.userJustLoggedIn}
								/>
							) : (
								<Login
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputEmail={props.loginInputEmail}
									loginInputPassword={props.loginInputPassword}
								/>
							)}
							<Note textColor={vars.grey_2_5}>
								Please note: This site works best in Chrome or FireFox browsers
							</Note>
						</Switch>
					);
				}}
			</Transition>
		</div>
	);
};

LoginSwitch.propTypes = {
	codeDeliveryMessage: PropTypes.string.isRequired,
	createNewPassword: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired,
	forceChangePassword: PropTypes.bool.isRequired,
	forgotPassword: PropTypes.bool.isRequired,
	loginInputChangePasswordNew: PropTypes.string.isRequired,
	loginInputChangePasswordOld: PropTypes.string.isRequired,
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,
	loginInputEmail: PropTypes.string.isRequired,
	loginInputPassword: PropTypes.string.isRequired,
	loginInputVerificationCode: PropTypes.string.isRequired,
	loginInputNewPassword: PropTypes.string.isRequired,
	userJustLoggedIn: PropTypes.bool.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
};

export default LoginSwitch;
